/**
 * Utility functions for Google Maps API
 */

export const waitForGoogleMaps = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Check if Google Maps is already loaded
    if (typeof window.google !== 'undefined' && window.google.maps) {
      resolve();
      return;
    }

    // Wait for Google Maps to load
    const checkGoogleMaps = () => {
      if (typeof window.google !== 'undefined' && window.google.maps) {
        resolve();
      } else {
        setTimeout(checkGoogleMaps, 100);
      }
    };

    // Start checking
    checkGoogleMaps();

    // Timeout after 10 seconds
    setTimeout(() => {
      reject(new Error('Google Maps API failed to load within 10 seconds'));
    }, 10000);
  });
};

export const isGoogleMapsLoaded = (): boolean => {
  return typeof window.google !== 'undefined' && !!window.google.maps;
};
